import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomerAdminOverviewPage } from './customer-admin-overview.page';

const routes: Routes = [
  {
    path: '',
    component: CustomerAdminOverviewPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerAdminOverviewPageRoutingModule {}
